import React, { CSSProperties, FC, Fragment, useEffect, useState } from 'react';
import { NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import authService from '../../../services/AuthService';
import { ApplicationPaths } from '../Auth.model';
import { LoginMenuProps } from './LoginMenu.model';
import {FaSignInAltIcon, FiLogOutIcon} from "../../../models/Icons.model";

const LoginMenu: FC<LoginMenuProps> = (props) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userName, setUserName] = useState<string | null>(null);

  const populateState = async () => {
    const [nextIsAuthenticated, user] = await Promise.all([
      authService.isAuthenticated(),
      authService.getUser()
    ]);

    setIsAuthenticated(nextIsAuthenticated);
    setUserName((user && user.name) || null);
  };

  useEffect(() => {
    const subscription = authService.subscribe(() => populateState());
    populateState();

    return () => {
      authService.unsubscribe(subscription);
    };
  }, []);

  const authenticatedView = (
    currentUserName: string | null,
    profilePath: string,
    logoutPath: string,
    logoutState: { local: boolean }
  ) => {
    const { className, showLabel, itemClassName, hideIcon, menuWidth } = props || {};
    const baseClass = className && className.includes("tab-btn")
      ? className
      : `header-auth-link d-sm-inline-flex ${className || ""}`.trim();

    return (
      <Fragment>
        <NavItem style={{ listStyle: 'none' }} className={itemClassName}>
          <NavLink
            style={menuWidth ? { width: menuWidth } as CSSProperties : undefined}
            replace
            tag={Link}
            className={baseClass}
            to={'/'}
            state={logoutState}
          >
            {!hideIcon ? <FiLogOutIcon className="header-auth-link__icon" /> : null}
            {showLabel ? <span style={{ fontSize: 16 }}>Выйти</span> : null}
          </NavLink>
        </NavItem>
      </Fragment>
    );
  };

  const anonymousView = (registerPath: string, loginPath: string) => {
    const { className, showLabel, itemClassName, hideIcon } = props || {};
    const baseClass = className && className.includes("tab-btn")
      ? className
      : `header-auth-link d-sm-inline-flex ${className || ""}`.trim();

    return (
      <Fragment>
        <NavItem className={itemClassName}>
          <NavLink tag={Link} className={baseClass} to={loginPath}>
            {!hideIcon ? <FaSignInAltIcon className="header-auth-link__icon" /> : null}
            {showLabel ? <span className="ms-2">Вход</span> : null}
          </NavLink>
        </NavItem>
      </Fragment>
    );
  };

  if (!isAuthenticated) {
    const registerPath = `${ApplicationPaths.Register}`;
    const loginPath = `${ApplicationPaths.DefaultLoginRedirectPath}`;
    return anonymousView(registerPath, loginPath);
  }

  const profilePath = `${ApplicationPaths.Profile}`;
  const logoutPath = `${ApplicationPaths.LogOut}`;
  const logoutState = { local: true };
  return authenticatedView(userName, profilePath, logoutPath, logoutState);
};

export { LoginMenu };
